import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import RadarIcon from '@mui/icons-material/Radar';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import HistoryIcon from '@mui/icons-material/History';
import CasinoIcon from '@mui/icons-material/Casino';
import { useAuth } from '../contexts/AuthContext';

const FEATURES = [
  {
    icon: <DashboardIcon color="primary" />,
    title: 'Dashboard',
    text: 'Realized and unrealized P/L at a glance, win rate, profit factor, and per-symbol performance.'
  },
  {
    icon: <AssessmentIcon color="primary" />,
    title: 'Position Summary',
    text: 'Open positions, option spreads, working trades, and closed positions grouped by week or month.'
  },
  {
    icon: <AccountBalanceIcon color="primary" />,
    title: 'Accounts',
    text: 'Connect Schwab, Tradier, Robinhood, and Plaid — or track manual accounts — all in one place.'
  },
  {
    icon: <HistoryIcon color="primary" />,
    title: 'Order History',
    text: 'Full trade history with FIFO reconciliation, realized P/L, and dividend tracking.'
  },
  {
    icon: <RadarIcon color="primary" />,
    title: 'Scanner',
    text: 'Scan the market for setups and send qualifying candidates straight to your orders.'
  },
  {
    icon: <TrendingUpIcon color="primary" />,
    title: 'Stock Analysis',
    text: 'Per-symbol deep dives: open positions, cost basis, and trade-level breakdowns.'
  },
  {
    icon: <NotificationsActiveIcon color="primary" />,
    title: 'Alerts',
    text: 'Webhook, Discord, Telegram, and price alerts — plus earnings reminders before you trade.'
  },
  {
    icon: <CasinoIcon color="primary" />,
    title: 'Paper Trading',
    text: 'Practice strategies risk-free with a simulated account that mirrors the real workflow.'
  }
];

const FeatureSplash = () => {
  const { user, markSplashSeen } = useAuth();

  if (!user || user.splashSeen) return null;

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', pb: 0 }}>
        <Typography variant="h4" component="div" gutterBottom>
          Welcome to MyTradesHub
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Here's what you can do
        </Typography>
      </DialogTitle>
      <DialogContent>
        <List dense>
          {FEATURES.map((f) => (
            <ListItem key={f.title} alignItems="flex-start">
              <ListItemIcon sx={{ mt: 0.5 }}>{f.icon}</ListItemIcon>
              <ListItemText
                primary={f.title}
                secondary={f.text}
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button variant="contained" size="large" onClick={markSplashSeen} sx={{ px: 5 }}>
          Get Started
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeatureSplash;
